import { GraphQLClient, gql } from 'graphql-request';

const API = process.env.NEXT_PUBLIC_SP4E_JCBW_API_URL ?? 'https://info.cld.hkjc.com/graphql/base/';
// process.env.NEXT_PUBLIC_SP4E_JCBW_API_URL ?? 'https://info2nd.cld.qcew.com/graphql/base/';
// const API = process.env.SITECORE_EDGE_GRAPH_URL ?? 'https://info.cld.qcew.com/graphql/base/';

const client = new GraphQLClient(API);

const QUERY = `fragment raceFragment on Race {
  id
  no
  status
  raceName_en
  raceName_ch
  postTime
  country_en
  country_ch
  distance
  wageringFieldSize
  go_en
  go_ch
  ratingType
  raceTrack {
    description_en
    description_ch
  }
  raceCourse {
    description_en
    description_ch
    displayCode
  }
  claCode
  raceClass_en
  raceClass_ch
  judgeSigns {
    value_en
  }
}
 
fragment racingBlockFragment on RaceMeeting {
  jpEsts: pmPools(
    oddsTypes: [TCE, TRI, FF, QTT, DT, TT, SixUP]
    filters: ["jackpot", "estimatedDividend"]
  ) {
    leg {
      number
      races
    }
    oddsType
    jackpot
    estimatedDividend
    mergedPoolId
  }
  poolInvs: pmPools(
    oddsTypes: [WIN, PLA, QIN, QPL, CWA, CWB, CWC, IWN, FCT, TCE, TRI, FF, QTT, DBL, TBL, DT, TT, SixUP]
  ) {
    id
    leg {
      races
    }
  }
  penetrometerReadings(filters: ["first"]) {
    reading
    readingTime
  }
  hammerReadings(filters: ["first"]) {
    reading
    readingTime
  }
  changeHistories(filters: ["top3"]) {
    type
    time
    raceNo
    runnerNo
    horseName_ch
    horseName_en
    jockeyName_ch
    jockeyName_en
    scratchHorseName_ch
    scratchHorseName_en
    handicapWeight
    scrResvIndicator
  }
}
 
fragment racingFoPoolFragment on RacingFoPool {
  instNo
  poolId
  oddsType
  status
  sellStatus
  otherSelNo
  inplayUpTo
  expStartDateTime
  expStopDateTime
  raceStopSellNo
  raceStopSellStatus
  includeRaces
  excludeRaces
  lastUpdateTime
  selections {
    order
    number
    code
    name_en
    name_ch
    scheduleRides
    remainingRides
    points
    lineId
    combId
    combStatus
    openOdds
    prevOdds
    currentOdds
    results {
      raceNo
      points
      point1st
      point2nd
      point3rd
      dhRmk1st
      dhRmk2nd
      dhRmk3rd
      count1st
      count2nd
      count3rd
      count4th
      numerator4th
      denominator4th
    }
  }
  otherSelections {
    order
    code
    name_en
    name_ch
    scheduleRides
    remainingRides
    points
    results {
      raceNo
      points
      point1st
      point2nd
      point3rd
      dhRmk1st
      dhRmk2nd
      dhRmk3rd
      count1st
      count2nd
      count3rd
      count4th
      numerator4th
      denominator4th
    }
  }
}
 
query racing($date: String, $venueCode: String, $foOddsTypes: [OddsType], $foFilter: [String], $resultOddsType: [OddsType]) {
  timeOffset {
    rc
  }
  activeMeetings: raceMeetings {
    id
    venueCode
    date
    status
    races {
      no
      postTime
      status
      wageringFieldSize
    }
  }
  raceMeetings(date: $date, venueCode: $venueCode) {
    id
    status
    venueCode
    date
    totalNumberOfRace
    currentNumberOfRace
    dateOfWeek
    meetingType
    totalInvestment
    country {
      code
      namech
      nameen
      seq
    }
    races {
      ...raceFragment
      runners {
        id
        no
        standbyNo
        status
        name_ch
        name_en
        horse {
          id
          code
        }
        color
        barrierDrawNumber
        handicapWeight
        currentWeight
        currentRating
        internationalRating
        gearInfo
        racingColorFileName
        allowance
        trainerPreference
        last6run
        saddleClothNo
        trumpCard
        priority
        finalPosition
        deadHeat
        winOdds
        jockey {
          code
          name_en
          name_ch
        }
        trainer {
          code
          name_en
          name_ch
        }
      }
    }
    obSt: pmPools(oddsTypes: [WIN, PLA]) {
      leg {
        races
      }
      oddsType
      comingleStatus
    }
    poolInvs: pmPools(
      oddsTypes: [WIN, PLA, QIN, QPL, CWA, CWB, CWC, IWN, FCT, TCE, TRI, FF, QTT, DBL, TBL, DT, TT, SixUP]
    ) {
      id
      leg {
        number
        races
      }
      status
      sellStatus
      oddsType
      investment
      mergedPoolId
      lastUpdateTime
    }
    resPools: pmPools(oddsTypes: $resultOddsType) {
      leg {
        number
        races
      }
      status
      oddsType
      name_en
      name_ch
      lastUpdateTime
      dividends(officialOnly: true) {
        winComb
        type
        div
        seq
        status
        guarantee
        partial
        partialUnit
      }
      cWinSelections {
        composite
        name_ch
        name_en
        starters
      }
    }
    ...racingBlockFragment
    pmPools(oddsTypes: []) {
      id
    }
    foPools(oddsTypes: $foOddsTypes, filters: $foFilter) {
      ...racingFoPoolFragment
    }
    jkcInstNo: foPools(oddsTypes: [JKC], filters: ["top"]) {
      instNo
    }
    tncInstNo: foPools(oddsTypes: [TNC], filters: ["top"]) {
      instNo
    }
  }
}
`;

export async function GetRacingDataQuery(date: string, venueCode: string) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const data = await client.request<any>(
            gql`
                ${QUERY}
            `,
            { date, venueCode, foOddsType: [], foFilter: ['top'], resultOddsType: [] }
        );
        return data.raceMeetings;
    } catch (error) {
        console.error('Error fetching news data:', error);
        throw error;
    }
}
